import { SelectInput } from '@framework/form';
import { Space } from 'antd';
import React from 'react';
import { IconType, IconTypeList } from '../advanced/buttons/icons/Icons';

export interface IIconTypeSelectInputProps {
  name: string;
  defaultValue?: IconType;
  placeholder?: string;
}

export function IconTypeSelectInput(props: IIconTypeSelectInputProps) {
  return (
    <SelectInput
      name={props.name}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
      optionFilterProp="searchable"
      options={IconTypeList.map(icon => ({
        label: (
          <Space>
            {icon.icon}
            <span>{icon.label}</span>
          </Space>
        ),
        searchable: icon.label,
        value: icon.type,
      }))}
    />
  );
}
